document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('details.vertical-menu li.submenu-container');

  items.forEach(li => {
    const trigger = li.querySelector('a.vertical-menu-item');
    const submenu = li.querySelector('.submenu-design__simple');
    if (!trigger || !submenu) return;

    let t;

    const open = () => {
      clearTimeout(t);
      li.classList.add('pawroutine-keepopen');
    };

    const close = () => {
      clearTimeout(t);
      t = setTimeout(() => li.classList.remove('pawroutine-keepopen'), 250);
    };

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', close);
    submenu.addEventListener('mouseenter', open);
    submenu.addEventListener('mouseleave', close);
  });
});
